import { identity } from '../utils/identity';

const REGEX = /[^a-zа-яё0-9\-']+/i;

// Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
export const simpleTokenizer = function(text: string) {
  return text
    .split(REGEX)
    // filter empty tokens
    .filter(identity);
};
